import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Marker, Tooltip } from "react-leaflet";
import { roleIcon } from "./roleMarkers";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const icon = roleIcon("artisan", { size: 34 });

// Artisans disponibles proches (affichage gratuit) ; un tap ouvre la fiche (pass 100 FCFA = 5 fiches)
export const NearbyArtisans = ({ pos }) => {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const lat = pos?.[0];
  const lng = pos?.[1];

  useEffect(() => {
    if (lat == null || lng == null) return;
    axios.get(`${API}/artisans/nearby`, { params: { latitude: lat, longitude: lng, radius_km: 10 } })
      .then((r) => setList(r.data || []))
      .catch(() => setList([]));
  }, [lat, lng]);

  return list.map((a) => (
    <Marker
      key={a.user_id}
      position={[a.base_latitude, a.base_longitude]}
      icon={icon}
      zIndexOffset={1000}
      eventHandlers={{ click: () => navigate(`/artisans/${a.user_id}`) }}
    >
      <Tooltip direction="top" offset={[0, -14]}>
        <span data-testid={`home-artisan-pin-${a.user_id}`}>{a.full_name || "Artisan"} · {a.distance_km} km</span>
      </Tooltip>
    </Marker>
  ));
};
